const isBrowser = typeof window !== "undefined";

export class Storage {
  static getString(key: string): string | null {
    if (!isBrowser) return null;
    return localStorage.getItem(key);
  }

  static delete(key: string) {
    if (!isBrowser) return;
    localStorage.removeItem(key);
  }

  static setString(key: string, value: string) {
    if (!isBrowser) return;
    localStorage.setItem(key, value);
  }

  static getCurrentUserToken(): string | null | undefined {
    const userString = Storage.getString("currentUser");
    const user = userString ? JSON.parse(userString) : null;
    return user?.accessToken;
  }

  static setBoolean(key: string, value: boolean) {
    if (!isBrowser) return;
    localStorage.setItem(key, value.toString());
  }

  static getBoolean(key: string): boolean {
    if (!isBrowser) return false;
    return localStorage.getItem(key) === "true";
  }
}
